import { render } from "./ReturnItemsChoiceAppModal.vue?vue&type=template&id=081c6612"
import script from "./ReturnItemsChoiceAppModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnItemsChoiceAppModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/modal/ReturnItemsChoiceAppModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "081c6612"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('081c6612', __exports__)) {
    console.log('reload')
    api.reload('081c6612', __exports__)
  }
  
  module.hot.accept("./ReturnItemsChoiceAppModal.vue?vue&type=template&id=081c6612", () => {
    console.log('re-render')
    api.rerender('081c6612', render)
  })

}


export default __exports__